import { useEffect, useState } from "react";

import { ReasonKinds } from "@featbit/js-client-sdk";

import { isFeatureFlagsEnabled, useFeatureFlag } from "utils";

import { FEATURE_FLAGS, SOIL_SIGHT_SKIP_FLAG_WAIT_MS } from "consts";

// TODO(KH-1131): remove with the skip-acquisition-flow flag. Until the flag loads, visitors get the full flow.
export const useSkipAcquisitionFlow = () => {
  const { isEnabled, kind } = useFeatureFlag(FEATURE_FLAGS.SOIL_SIGHT_SKIP_ACQUISITION_FLOW);
  const [hasWaitTimedOut, setHasWaitTimedOut] = useState(false);
  // An env-disabled SDK stays ClientNotReady forever, so only a configured SDK can still be loading.
  const isFlagLoaded = kind !== ReasonKinds.ClientNotReady || !isFeatureFlagsEnabled();

  useEffect(() => {
    if (isFlagLoaded) return undefined;
    // A FeatBit outage must not leave a direct link waiting forever.
    const timeoutId = window.setTimeout(() => setHasWaitTimedOut(true), SOIL_SIGHT_SKIP_FLAG_WAIT_MS);
    return () => window.clearTimeout(timeoutId);
  }, [isFlagLoaded]);

  return { isSkipEnabled: isEnabled, isResolved: isFlagLoaded || hasWaitTimedOut };
};
